import Image from 'next/image'

import CustomerStoryWithTiles from '@/components/CustomerStoryWithTiles'

const MoominCustomerStory = () => {
    return (
        <CustomerStoryWithTiles
            light={false}
            backgroundImage={'/images/customer-quotes/moomin-story-desktop.png'}
            mobileBackgroundImage={'/images/customer-quotes/moomin-story-mobile.png'}
            logo={
                <Image
                    src={'/images/logos/moomin.png'}
                    height={32}
                    width={117.33}
                    alt={'Moomin customer story'}
                />
            }
            text={
                <>
                    Eager to accelerate emissions reductions, Moomin budgeted €100,000 annually to
                    fund high-impact carbon projects aligned to the Oxford Offsetting Principles.
                    <br />
                    <br />
                    This contribution-led approach let them maximize climate impact while they
                    embarked on their road to decarbonisation.
                </>
            }
            button={{
                label: 'Moomin’s sustainability page',
                href: 'https://sustainability.lune.co/moomin',
                target: '_blank',
            }}
        />
    )
}

export default MoominCustomerStory
